import {
  _getFullPermissions,
  getFullPermissions,
  _getAccessPermission,
  getAccessPermission,
} from 'reducers/PermissionsReducer';
import { PERMISSION_SCOPES, PERMISSION_TYPES } from '../constants/permissionResources';

// Pure lookup for selectors or callers with a permissions snapshot.
export const selectResourcePermissions = (
  permissions,
  resource,
  agencyId = PERMISSION_SCOPES.ANY
) =>
  resource.type === PERMISSION_TYPES.ACCESS
    ? _getAccessPermission(resource.group, resource.name, agencyId, permissions)
    : _getFullPermissions(resource.group, resource.name, agencyId, permissions);

// Store-backed lookup for code outside React.
export const getResourcePermissions = (resource, agencyId = PERMISSION_SCOPES.ANY) =>
  resource.type === PERMISSION_TYPES.ACCESS
    ? getAccessPermission(resource.group, resource.name, agencyId)
    : getFullPermissions(resource.group, resource.name, agencyId);
